module.exports = __webpack_public_path__ + "static/media/ozio.488a0f7c.png";